/* eslint-disable no-unused-vars */
import React, { PropTypes } from 'react';
import LinearProgress from 'material-ui/LinearProgress';

class LoadingContainer extends React.Component {
  static propTypes = {
    init: PropTypes.func,
    loading: PropTypes.bool,
    childrenComponent: PropTypes.func,
    childrenProps: PropTypes.object
  };

  componentDidMount() {
    let { init } = this.props;

    if (init) {
      init(this.props);
    }
  }

  render() {
    let {
      loading,
      childrenComponent,
      childrenProps,
      init,
      ...other
    } = this.props;

    let style = {
      loading: {
        position: 'Fixed',
        top: 64,
        left: 0,
        right: 0,
        width: '100%'
      }
    };

    return (
      <div>
        {loading ? (
          <div style={style.loading}>
            <LinearProgress mode="indeterminate" />
          </div>
        ) : (
          React.createElement(
            childrenComponent,
            Object.assign(other, childrenProps),
          )
        )}
      </div>
    );
  }
}

export default LoadingContainer;



// WEBPACK FOOTER //
// ./src/components/LoadingContainer/LoadingContainer.jsx